/**
 * Generates the fallback url from a translation key
 * in the following format: "[lastpartofkey]"
 *
 * So for example: a fallback for "STO.COMMON.SOMETHING" would be "[something]"
 */
export const messageKeyToFallback = (key: string) => `[${key.replace(/.*\./g, '').toLowerCase()}]`
